import repositoryFactory from '@/helpers/api/apiFactory';
const api = repositoryFactory('comparing');

const state = { 
    comparing: null,
    matches: null
};

const mutations = {
    setState: (state, {key, value}) => {
        state[key] = value;
    }
};

const actions = {   
    async get({commit, state}) { 
        try {
            const response = await api.get();  
        
            commit('setState', {
                key: 'comparing',
                value: response.data.data != undefined ? response.data.data : []
            });

            commit('setState', {
                key: 'matches',
                value: response.data.matches != undefined ? response.data.matches : []
            });
        } catch (err) {} 
    },  

    async add({commit}, id) { 
        return await api.add(id); 
    },

    async remove({commit}, id) { 
        return await api.remove(id); 
    },

    async clear({dispatch}) {
        const response = await api.clear();  

        dispatch('get');
        return response;
    }
};

const getters = {  
    comparing: state => state.comparing,
    matches: state => state.matches
};

export default {
    namespaced: true,
    state, 
    mutations,
    actions,
    getters
}; 